import { isWeb } from '@helpers';
import { sendToDatadog } from '@reducers/dataDogs';
import { LOGGER_TITLES } from '@reducers/dataDogs/constants';
import { TRACKING_API_KEY, TRACKING_ENDPOINTS } from '@services/tracking/config';
import type { TrackingInstance } from '@services/tracking/types';
import '@services/tracking/types';

let isInitialized = false;
let trackingInstance: TrackingInstance | null = null;

// check if tracking is initialized
export const isTrackingInitialized = (): boolean => isInitialized;

export const getTrackingInstance = (): TrackingInstance | null => trackingInstance;

export const initTracking = async (): Promise<void> => {
  if (isInitialized) return;

  try {
    if (isWeb) {
      // On web, SDK script is loaded in index.html but NOT initialized there.
      // We init here (after auth) to prevent anonymous sessions/users from autocapture.
      if (window.amplitude) {
        window.amplitude.init(TRACKING_API_KEY, {
          fetchRemoteConfig: true,
          serverZone: 'EU',
          serverUrl: TRACKING_ENDPOINTS.TRACKING_SERVER_URL,
          autocapture: false,
        });
        trackingInstance = window.amplitude;
        isInitialized = true;
      }
    } else {
      // On mobile, use React Native SDK
      const amplitudeRN = require('@amplitude/analytics-react-native');

      await amplitudeRN.init(TRACKING_API_KEY, undefined, {
        serverZone: 'EU',
        fetchRemoteConfig: true,
        serverUrl: TRACKING_ENDPOINTS.TRACKING_SERVER_URL,
        // Skip CookieStorage probing inside the RN SDK - `document.cookies` is undefined on native.
        // Persistence still falls through to AsyncStorage via LocalStorage.
        disableCookies: true,
      }).promise;

      // TODO: Session Replay temporarily disabled for native devices since we have disabled it for web as well;
      // try {
      //   const { sessionReplayPlugin } = require('@amplitude/plugin-session-replay-react-native');
      //   await amplitudeRN.add(sessionReplayPlugin({ sampleRate: 0.25, enableRemoteConfig: true }));
      // } catch (srError) {
      //   sendToDatadog(
      //     [{ error: srError instanceof Error ? srError.message : 'Unknown error', service: 'amplitude-session-replay' }],
      //     'Session Replay plugin failed',
      //     'warn'
      //   );
      // }

      trackingInstance = amplitudeRN as TrackingInstance;
      isInitialized = true;
    }
  } catch (error) {
    const errorMessage = error instanceof Error ? error.message : 'Unknown error';
    sendToDatadog(LOGGER_TITLES.AMPLITUDE_INIT_FAILED, { error: errorMessage, service: 'amplitude', platform: isWeb ? 'web' : 'native' }, 'error');
  }
};
